import React from "react";

export default function ColorFrame37({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <path
          fill="#fff"
          stroke="#AA82DB"
          strokeWidth="20"
          d="M230 176.319c0 48.126-40.794 87.843-92 87.843-51.207 0-92-39.717-92-87.843 0-48.125 40.793-87.842 92-87.842 51.206 0 92 39.717 92 87.842z"
        ></path>
        <path
          fill="#F1BFA3"
          d="M143.097 20.919c-1.387-1.674-5.316-3.138-5.547-.419-.231 2.72-.859 72.585-.693 76.556.165 3.971-.891 8.015 5.615 14.282 6.507 6.266 32.493 8.282 33.526 5.316.66-1.894-7.618-5.362-13.684-7.62-3.476-1.294-5.591-4.908-5.023-8.559 1.651-10.62 3.953-31.966-1.633-44.456-4.119-9.212-7.042-18.8-8.862-25.688-1.561-5.907-2.312-7.739-3.699-9.412z"
        ></path>
        <path
          fill="#FFD1B7"
          d="M144.122 28.992c-1.926-1.818-3.961-.702-4.816 1.001-.778 1.553-.167 8.797-.052 10.067.011.13.02.255.025.385l1.592 38.172c.165 3.977 3.524 7.09 7.502 6.954l.349-.012c3.611-.123 6.55-2.894 6.809-6.495.604-8.424 1.364-22.579-.173-24.71-1.93-2.676-4.464-11.396-5.076-13.564a7.204 7.204 0 00-.34-.957c-.85-1.927-4.15-9.266-5.82-10.841z"
        ></path>
        <path
          fill="#FFD1B7"
          d="M151.226 44.03c-2.037-5.818-9.281-3.816-11.472 1.913-.146.382-.213.79-.195 1.2l2.096 50.286c.165 3.976 3.524 7.09 7.502 6.954l3.916-.133a7.14 7.14 0 006.574-4.98l6.031-19.04a6.983 6.983 0 00.085-3.966c-1.076-3.902-3.623-12.695-6.348-18.909-2.471-5.636-6.088-7.327-8.189-13.326z"
        ></path>
        <path
          fill="#FFD1B7"
          d="M173.628 93.082c-2.845-2.546-6.642-15.053-8.647-18.753l-10.883-.256c-4.17 7.259-12.474 22.613-12.335 25.958.174 4.18 3.164 9.311 10.73 13.239 6.053 3.142 24.189 6.849 32.501 8.31l6.246-22.191c-5.009-1.783-14.008-3.08-17.612-6.307z"
        ></path>
        <path
          fill="#7C4EB7"
          d="M199.472 92.828c.285-1.252-.568-2.439-1.855-2.581l-19.851-2.188c-1.147-.127-2.235.627-2.509 1.739l-7.755 31.414a2.105 2.105 0 001.647 2.588l20.021 4.047c1.218.246 2.442-.541 2.717-1.746l7.585-33.273z"
        ></path>
        <path
          fill="#F1BFA3"
          d="M132.143 20.919c1.387-1.674 5.317-3.138 5.548-.419.231 2.72.858 72.585.693 76.556-.166 3.971.891 8.015-5.616 14.282-6.507 6.266-32.492 8.282-33.525 5.316-.66-1.894 7.617-5.362 13.683-7.62 3.476-1.294 5.591-4.908 5.023-8.559-1.651-10.62-3.953-31.966 1.633-44.456 4.12-9.212 7.042-18.8 8.862-25.688 1.561-5.907 2.312-7.739 3.699-9.412z"
        ></path>
        <path
          fill="#FFD1B7"
          d="M131.118 28.992c1.926-1.818 3.962-.702 4.816 1.001.779 1.553.167 8.797.052 10.067-.011.13-.02.255-.025.385l-1.591 38.172c-.166 3.977-3.525 7.09-7.503 6.954l-.349-.012c-3.611-.123-6.55-2.894-6.808-6.495-.605-8.424-1.364-22.579.172-24.71 1.93-2.676 4.464-11.396 5.076-13.564.092-.328.203-.645.34-.957.85-1.927 4.15-9.266 5.82-10.841z"
        ></path>
        <path
          fill="#FFD1B7"
          d="M124.014 44.03c2.037-5.818 9.281-3.816 11.472 1.913.146.382.213.79.196 1.2l-2.096 50.286c-.166 3.976-3.525 7.09-7.503 6.954l-3.916-.133a7.14 7.14 0 01-6.574-4.98l-6.03-19.04a6.974 6.974 0 01-.086-3.966c1.076-3.902 3.623-12.695 6.348-18.909 2.472-5.636 6.088-7.327 8.189-13.326z"
        ></path>
        <path
          fill="#FFD1B7"
          d="M101.613 93.082c2.844-2.546 6.641-15.053 8.646-18.753l10.883-.256c4.17 7.259 12.474 22.613 12.335 25.958-.174 4.18-3.164 9.311-10.73 13.239-6.053 3.142-24.19 6.849-32.5 8.31L84 99.389c5.009-1.783 14.007-3.08 17.612-6.307z"
        ></path>
        <path
          fill="#7C4EB7"
          d="M75.769 92.828c-.286-1.252.567-2.439 1.854-2.581l19.852-2.188c1.146-.127 2.234.627 2.509 1.739l7.754 31.414a2.105 2.105 0 01-1.647 2.588l-20.02 4.047c-1.219.246-2.443-.541-2.718-1.746L75.77 92.828z"
        ></path>
        <rect
          width="6.098"
          height="19.402"
          x="193.383"
          y="42.527"
          fill="#AA82DB"
          rx="3.049"
          transform="rotate(82.535 193.383 42.527)"
        ></rect>
        <rect
          width="6.098"
          height="19.402"
          fill="#AA82DB"
          rx="3.049"
          transform="scale(-1 1) rotate(82.535 -64.248 -24.338)"
        ></rect>
        <rect
          width="6.098"
          height="15.986"
          fill="#AA82DB"
          rx="3.049"
          transform="scale(-1 1) rotate(69.847 -134.802 -94.648)"
        ></rect>
        <rect
          width="6.098"
          height="15.986"
          x="95.355"
          y="64.51"
          fill="#AA82DB"
          rx="3.049"
          transform="rotate(69.847 95.355 64.51)"
        ></rect>
        <rect
          width="6.098"
          height="19.402"
          fill="#AA82DB"
          rx="3.049"
          transform="scale(-1 1) rotate(59.712 -58.743 -68.746)"
        ></rect>
        <rect
          width="6.098"
          height="19.402"
          x="182.47"
          y="16.651"
          fill="#AA82DB"
          rx="3.049"
          transform="rotate(59.712 182.47 16.651)"
        ></rect>
        {children}
      </g>
    </svg>
  );
}
